module.exports = __webpack_public_path__ + "img/4-1.25a3ec8a.png";